/* eslint-disable */

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function DetailsGoogleSheetV2() {
  const [buttonText, setButtonText] = useState("نسخ البريد الإلكتروني");
  const [copySuccess, setCopySuccess] = useState(false);
  const { t } = useTranslation();

  const serviceEmail = "google-sheet@foorweb-475912.iam.gserviceaccount.com";

  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(serviceEmail)
        .then(() => {
          setButtonText("تم نسخ البريد الإلكتروني");
          setCopySuccess(true);
          // إعادة النص الأصلي بعد مرور 3 ثواني
          setTimeout(() => {
            setButtonText("نسخ البريد الإلكتروني");
            setCopySuccess(false);
          }, 3000);
        })
        .catch((err) => {
          console.log("فشل النسخ", err);
          setButtonText("فشل النسخ");
        });
    } else {
      // إذا كانت Clipboard API غير مدعومة، نستخدم طريقة تقليدية
      const textArea = document.createElement("textarea");
      textArea.value = serviceEmail;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setButtonText("تم نسخ البريد الإلكتروني");
        setCopySuccess(true);
        setTimeout(() => {
          setButtonText("نسخ البريد الإلكتروني");
          setCopySuccess(false);
        }, 3000);
      } catch (err) {
        console.log("فشل النسخ", err);
        setButtonText("فشل النسخ");
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div className="min-h-[420px] h-fit" dir="rtl">
      <section className="cta-sec relative max-w-screen-xl px-4 md:px-8 h-fit mt-5 pt-0">
        <div className="flex flex-col md:flex-row">
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              {t("ui.sheetIntegrationSummary")}
              <span className="text-[#9e68ba]"> {t("servicePageDetails.upsell.highlight")}</span>
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              {t("services.google_sheet_description")}
            </p>
            <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] mb-4">
              <h4 className="font-medium text-[#9e68ba] mb-2">
                {t("services.key_features")}
              </h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("ui.sheetReceiveOrders")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("ui.sheetTeamSharing")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("ui.sheetTools")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("ui.sheetExport")}
                </li>
              </ul>
            </div>
            <a
              className="inline-flex items-center px-4 py-2 text-[#9e68ba] bg-[#fcf6ff] rounded-lg font-medium transition-colors hover:bg-[#faf1ff]"
              href="https://www.youtube.com/watch?v=cMWJRJb6s5w&t=5s"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 ml-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path
                  fillRule="evenodd"
                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                  clipRule="evenodd"
                />
              </svg>
              {t("services.watch_integration_video")}
            </a>
          </div>

          <div className="flex-1 mx-auto sm:w-9/12 lg:mt-0 h-fit lg:w-auto mr-2"></div>
          <div className="flex-1 mx-auto sm:w-9/12 lg:w-auto">
            <iframe
              className="w-full h-72 rounded-2xl border dark:!border-[#3c3a3d]"
              src="https://www.youtube.com/embed/cMWJRJb6s5w?si=qGcdKwgt0BZQgtiv"
              title={t("services.facebook_pixel_youtube_video_title")}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <div className="bg-blue-50 rounded-xl p-4 mx-2 border border-blue-100 mb-6">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          <div className="mb-4">
            <h3 className="text-blue-800 text-xl font-bold mb-3">
              {t("ui.sheetIntegrationSteps")}
            </h3>
            <div className="space-y-3 text-gray-700">
              <div className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center ml-3 mt-0.5 flex-shrink-0 text-sm font-bold">
                  1
                </span>
                <p className="leading-relaxed">
                  {t("ui.sheetEditorStep")}
                </p>
              </div>
              <div className="flex items-start">
                <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center ml-3 mt-0.5 flex-shrink-0 text-sm font-bold">
                  2
                </span>
                <p className="leading-relaxed">
                  {t("ui.sheetDetailsStep")}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-4 border border-blue-200">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-600 mb-1 font-medium">
                  {t("ui.accountEmailLabel")}
                </p>
                <p className="text-blue-900 font-mono text-sm break-all bg-blue-50 p-2 rounded border border-blue-100">
                  {serviceEmail}
                </p>
              </div>
              <button
                onClick={copyToClipboard}
                className="w-full sm:w-auto px-6 py-2.5 bg-blue-800 hover:bg-blue-900 text-white font-medium rounded-lg transition-colors"
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
